import { Alert, AlertDescription, AlertIcon, Box, forwardRef, StyleProps } from '@bonusly/design-system';

import { useActionInput } from '../context';
import { MultipleErrors, SingleError } from './feedback';

export type ActionFeedbackProps = StyleProps;

/**
 * Display of client- and server-side messages
 */
export const ActionFeedback = forwardRef<ActionFeedbackProps, 'div'>((props, ref) => {
	const { errors } = useActionInput();

	if (!errors.length) {
		return null;
	}

	return (
		<Alert status="error" py={3} ref={ref} {...props}>
			<AlertIcon color="red.700" />
			<AlertDescription color="red.700">
				<Box pt={1}>
					{errors.length > 1 && <MultipleErrors errors={errors} />}
					{errors.length === 1 && <SingleError error={errors[0]} />}
				</Box>
			</AlertDescription>
		</Alert>
	);
});

ActionFeedback.displayName = 'ActionFeedback';
